import React, { useState, useMemo, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useForm } from 'react-form'
import { claimInviteWithVoucher, claimStageWithVoucher } from '../../actions/payment'
import Dialog from './../dialog'
import Text from '../../components/text'
import op from '../../util/objectPath'
import './styles.css'


const Voucherbutton = ({ stageId, inviteId, onStarted, onEnded, onCancel }) => {
  const [paymentState, setPaymentState] = useState('button')
  const dispatch = useDispatch()
  const success = useSelector(state => op(state, `payment.vouchers[${stageId || inviteId}].success`))

  const onVoucherClick = () => {
    setPaymentState('form')
    onStarted()
  }

  const onCancelClicked = () => {
    setPaymentState('button')
    onCancel()
  }

  const onVoucherFailedAck = () => {
    setPaymentState('button')
    onCancel()
  }

  useEffect(() => {
    console.log(paymentState, success)
    if (paymentState === 'submitted') {
      if (success === true) {
        setPaymentState('successful')
        onEnded()
      } else if (success === false) {
        setPaymentState('failed')
      }
    }
  }, [success, paymentState])

  const { Form, meta: { isSubmitting, canSubmit } } = useForm({
    defaultValues: useMemo( () => ({ email: '', voucher: '' }), []),
    onSubmit: async (submittedValues, instance) => {
      if (stageId != null) {
        await claimStageWithVoucher('Team for stage ' + stageId, stageId, submittedValues.email, submittedValues.voucher)(dispatch)
      } else if (inviteId != null) {
        await claimInviteWithVoucher(inviteId, submittedValues.email, submittedValues.voucher)(dispatch)
      }
      setPaymentState('submitted')
      onEnded()
    }
  })

  if (paymentState === 'button') {
    return <button type="submit" className="btn btn-primary" onClick={onVoucherClick}>Use voucher</button>
  } else {
    let content = null
    if (paymentState === 'form') {
      content = (<Form className='voucherbutton-form'>
          <div className="form-group">
            <label htmlFor="email">E-mail</label>
            <Text field="email" id="email" className="form-control" />
          </div>
          <div className="form-group">
            <label htmlFor="voucher">Voucher</label>
            <Text field="voucher" id="voucher" className="form-control" />
          </div>
          <button type="submit" className="btn btn-primary">Submit</button>
          <button type="button" className="btn btn-secondary" onClick={onCancelClicked}>Cancel</button>
        </Form>)
    } else if (paymentState === 'submitted') {
      content = 'Voucher submitted, now validating...'
    } else if (paymentState === 'successful') {
      content = 'Voucher redeemed successful, finishing up.'
    } else if (paymentState === 'failed') {
      content = (
        <div>
          <div>
            Failed to redeem voucher.
          </div>
          <div className="mt-3">
            <button type="button" className="btn btn-primary" onClick={onVoucherFailedAck}>Ok</button>
          </div>
        </div>)
    } else {
      return null
    }

    return <Dialog title='Redeem voucher'>{content}</Dialog>
  }
}

export default Voucherbutton